const ElectricityInfo = ({
  electricity,
}) => {
  if (!electricity) return null;

  return (
    <div className="em-electricity-info-card">
      <h3>
        Electricidad – Validación
      </h3>

      <div className="em-electricity-grid">
        <div className="em-electricity-row">
          <strong>Fuente:</strong>{" "}
          {electricity.source_used ===
          "invoice"
            ? "Factura"
            : "Medidor"}
        </div>

        <div className="em-electricity-row">
          <strong>Factura:</strong>{" "}
          {electricity.kWh_invoice?.toFixed(
            2
          )}{" "}
          kWh
        </div>

        <div className="em-electricity-row">
          <strong>Medidor:</strong>{" "}
          {electricity.kWh_meter?.toFixed(
            2
          )}{" "}
          kWh
        </div>

        <div className="em-electricity-row">
          <strong>Diferencia:</strong>{" "}
          {electricity.gap_kWh?.toFixed(
            2
          )}{" "}
          kWh
        </div>

        <div className="em-electricity-row">
          <strong>
            Precio Promedio:
          </strong>{" "}
          $
          {electricity.price_avg?.toFixed(
            2
          )}{" "}
          / kWh
        </div>
      </div>
    </div>
  );
};

export default ElectricityInfo;